import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { ChartsModule } from '@progress/kendo-angular-charts';
import { PDFModule } from '@progress/kendo-angular-grid';
import { ICON_SETTINGS } from '@progress/kendo-angular-icons';
import { IntlService } from '@progress/kendo-angular-intl';
import { PopupModule } from '@progress/kendo-angular-popup';
import { ProgressBarModule } from '@progress/kendo-angular-progressbar';
import { TooltipsModule } from '@progress/kendo-angular-tooltip';
import { AppComponent } from './app/app.component';
import { pmtRoutes } from './app/app.routes';
import { authInterceptor } from './app/services/auth.interceptor';
import { KendoGridService } from './app/services/kendo-grid.service';
import { FirstDayIntlService } from './app/services/local/first-day-intl.service';
import { RestService } from './app/services/rest.service';

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideRouter(pmtRoutes, withComponentInputBinding()),
    importProvidersFrom(
      NgbModalModule,
      ChartsModule,
      PopupModule,
      TooltipsModule,
      PDFModule,
      ProgressBarModule
    ),
    KendoGridService,
    RestService,
    { provide: ICON_SETTINGS, useValue: { type: 'font' } },
    { provide: IntlService, useClass: FirstDayIntlService },
    provideAnimationsAsync()
  ]
}).catch(err => console.error(err));
